import jsBridge from './index'
/**
 * 通过jsBridge的weixinShare方法修改app导航条名称
 * @param {String} shareType  0：分享朋友 /1：分享朋友圈
 * @param {String} titleName 标题
 * @param {String} describe 描述文字
 * @param {String} imageUrl 图片链接
 * @param {String} shareUrl H5链接地址
 */
export default function weixinShare(options = {}) {
  const {
    shareType = '',
    titleName = '',
    describe = '',
    imageUrl = '',
    shareUrl = ''
  } = options
  return jsBridge('weixinShare', {
    shareType,
    titleName,
    describe,
    imageUrl,
    shareUrl
  })
}
